import React from 'react';
import Snackbar from '@material-ui/core/Snackbar';
import SnackbarContent from '@material-ui/core/SnackbarContent';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';

// Aviso na tela, no lugar do alert() do navegador.
//
// O alert() trava a pagina inteira e so' sai no "OK" — brusco justo nas telas de
// senha, onde a pessoa ja' esta' com dificuldade pra entrar (revisao do Vitor no
// PR #8, item 5). Este componente usa o Snackbar do Material-UI, que o projeto
// ja' tem como dependencia.
//
// Erro fica na tela ate' a pessoa fechar; aviso comum some sozinho em 6s.

const CORES = {
  erro: '#d32f2f',
  sucesso: '#2e7d32',
  info: '#323232',
};

const Aviso = ({ aberto, texto, tipo = 'info', aoFechar }) => (
  <Snackbar
    open={Boolean(aberto)}
    autoHideDuration={tipo === 'erro' ? null : 6000}
    onClose={(evento, motivo) => {
      // Clique fora nao fecha: em texto de duas linhas da' pra perder o aviso sem ler.
      if (motivo === 'clickaway') return;
      if (aoFechar) aoFechar();
    }}
    anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
  >
    <SnackbarContent
      style={{ backgroundColor: CORES[tipo] || CORES.info, maxWidth: 480 }}
      message={<span style={{ whiteSpace: 'pre-line', lineHeight: 1.5 }}>{texto}</span>}
      action={[
        <IconButton key="fechar" color="inherit" onClick={aoFechar} aria-label="Fechar aviso">
          <CloseIcon style={{ fontSize: 18 }} />
        </IconButton>,
      ]}
    />
  </Snackbar>
);

export default Aviso;
